import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { IconCheck, IconX } from '../components/Icons';

export default function Disputes() {
  const [disputes, setDisputes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'disputes'), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(q, snap => {
      setDisputes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const handleUpdateStatus = async (id, status) => {
    const note = window.prompt("ॲडमिन टिप्पणी (Admin Note):", status === 'Approved' ? "Refund approved" : "Refund rejected");
    if (note !== null) {
      try {
        await updateDoc(doc(db, 'disputes', id), {
          status,
          adminNote: note,
          updatedAt: new Date().toISOString(),
        });
        alert(`स्टेटस ${status} करण्यात आले आहे!`);
      } catch (err) {
        alert("Error: " + err.message);
      }
    }
  };

  return (
    <div style={{ paddingBottom: 40 }}>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', margin: '0 0 6px 0' }}>
          ⭐ Customer Disputes & Refund Requests (तक्रार निवारण व रिफंड)
        </h2>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          ग्राहकांनी नोंदवलेल्या तक्रारी, रिफंडच्या विनंत्या आणि रेटिंग्जचे निवारण करा.
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>लोड होत आहे...</div>
        ) : disputes.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>कोणतीही नवीन तक्रार किंवा रिफंड मागणी नाही.</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border)', textAlign: 'left', color: 'var(--text-muted)' }}>
                  <th style={{ padding: '8px 12px' }}>तारीख</th>
                  <th style={{ padding: '8px 12px' }}>कस्टमर & फोन</th>
                  <th style={{ padding: '8px 12px' }}>ऑर्डर ID</th>
                  <th style={{ padding: '8px 12px' }}>तक्रार कारण</th>
                  <th style={{ padding: '8px 12px' }}>रिफंड रक्कम</th>
                  <th style={{ padding: '8px 12px' }}>स्टेटस</th>
                  <th style={{ padding: '8px 12px', textAlign: 'right' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {disputes.map(d => (
                  <tr key={d.id} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '10px 12px', whiteSpace: 'nowrap' }}>
                      {d.createdAt?.seconds ? new Date(d.createdAt.seconds * 1000).toLocaleDateString() : 'N/A'}
                    </td>
                    <td style={{ padding: '10px 12px' }}>
                      <div style={{ fontWeight: 800 }}>{d.customerName || 'Customer'}</div>
                      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>📞 {d.phone || 'N/A'}</div>
                    </td>
                    <td style={{ padding: '10px 12px', fontWeight: 700, color: 'var(--primary)' }}>
                      #{d.orderId?.slice(0, 8)}
                    </td>
                    <td style={{ padding: '10px 12px' }}>
                      <div style={{ fontWeight: 700 }}>{d.reason}</div>
                      {d.description && <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{d.description}</div>}
                    </td>
                    <td style={{ padding: '10px 12px', fontWeight: 800, color: 'var(--danger)' }}>
                      ₹{d.amount || 0}
                    </td>
                    <td style={{ padding: '10px 12px' }}>
                      <span className={`badge ${d.status === 'Approved' ? 'success' : d.status === 'Rejected' ? 'danger' : 'warning'}`}>
                        {d.status || 'Pending'}
                      </span>
                    </td>
                    <td style={{ padding: '10px 12px', textAlign: 'right' }}>
                      {d.status === 'Pending' && (
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                          <button
                            onClick={() => handleUpdateStatus(d.id, 'Approved')}
                            className="btn btn-success btn-sm"
                            style={{ padding: '4px 8px', fontSize: 11 }}
                          >
                            <IconCheck size={12} /> Refund
                          </button>
                          <button
                            onClick={() => handleUpdateStatus(d.id, 'Rejected')}
                            className="btn btn-danger btn-sm"
                            style={{ padding: '4px 8px', fontSize: 11 }}
                          >
                            <IconX size={12} /> Reject
                          </button>
                        </div>
                      )}
                      {d.adminNote && <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 2 }}>Note: {d.adminNote}</div>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
